import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es';
import en from 'vee-validate/dist/locale/en';
import store from '@/store';
import i18n from '@/plugins/i18n';
import _ from 'lodash';

Vue.use(VeeValidate, {
  locale: store.state.locale.locale,
  dictionary: {
    en: en,
    es: es
  },
  i18n
});

Validator.extend('strong_password', {
  validate: value => {
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');
    return strongRegex.test(value);
  }
});

Validator.extend('min_words', {
  validate: (value, args) => {
    if (!_.isString(value)) return value;
    return value.trim().replace(/\s{2,}/g, ' ').split(' ').length >= args[0];
  },
});

Validator.extend('max_words', {
  validate: (value, args) => {
    if (!_.isString(value)) return value;
    return value.trim().replace(/\s{2,}/g, ' ').split(' ').length <= args[0];
  },
});

Validator.extend('unique_email', {
  validate: async value => {
    try {
      const { data: response } = await axios.get(
        `/api/web/validate-email?email=${value}`
      );
      return response.status === 200 ? true : false;
    } catch (e) {
      return false;
    }
  }
});

Validator.extend('blocked_email', {
  validate: async value => {
    try {
      const { data: response } = await axios.get(
        `/api/web/check-email?email=${value}`
      );
      return response.status === 200 ? true : false;
    } catch (e) {
      return false;
    }
  }
});

Validator.extend('unique_username', {
  validate: async value => {
    try {
      const { data: response } = await axios.get(
        `/api/web/validate-username?username=${value}`
      );
      return response.status === 200 ? true : false;
    } catch (e) {
      return false;
    }
  }
});

Validator.extend('unique_phone_mobile', {
  validate: async value => {
    try {
      const { data: response } = await axios.get(
        `/api/web/validate-phone_mobile?phone_mobile=${value}`
      );
      return response.status === 200 ? true : false;
    } catch (e) {
      return false;
    }
  }
});


const dictionary = {
  en: {
    messages: {
      min_words: (value, args) => `The ${value} field must have at least ${args[0]} words.`,
      max_words: (value, args) => `The ${value} field must have less than ${args[0]} words.`,
      unique_username: value => `${value} has already been taken.`,
      unique_phone_mobile: value => `${value} has already been taken.`,
      unique_email: value => `${value} has already been taken.`,
      strong_password: value => `The ${value} is not valid.`,
      blocked_email: value => `User not found, please contact support`
    }
  },
  es: {
    messages: {
      min_words: (value, args) => `El campo ${value} debe tener al menos ${args[0]} palabras.`,
      max_words: (value, args) => `El campo ${value} debe tener menos de ${args[0]} palabras.`,
      unique_username: value => `${value} ya ha sido tomado.`,
      unique_phone_mobile: value => `${value} ya ha sido tomado.`,
      unique_email: value => `${value} ya ha sido tomado.`,
      strong_password: value => `La ${value} no es valida.`,
      blocked_email: value => `Usuario no encontrado, por favor contacta a soporte`
    }
  }
};

Validator.localize(dictionary);
